import React from 'react';
const ButtonContext = React.createContext({ useUppercase: true });
export default ButtonContext;
//# sourceMappingURL=button.js.map